import React, { FC, useEffect, useRef, useState } from 'react';
import s from './index.less';
import Modal from '@/components/Modal';
import { useIntl } from 'umi';
import classNames from 'classnames';
import { Input } from 'antd';
import { useMount } from 'ahooks';

interface PwdModalProps {
  visible: boolean;
  onClose: any;
  onOk: any;
}

const PwdModal: FC<PwdModalProps> = (props) => {
  const { visible, onClose, onOk } = props;
  const [password, setPassword] = useState('');
  const [passwordUI, setPasswordUI] = useState('');

  const inputRef = useRef<any>();
  const { formatMessage } = useIntl();
  const onPasswordChange = React.useCallback(
    (e: any) => {
      const inputString = e.target.value.replace(/\s/g, '');
      if (/^[0-9]+$/.test(inputString) || !inputString) {
        setPassword(inputString.slice(0, 6));

        if (e.target.value.length <= 3) {
          setPasswordUI(e.target.value);
        } else if (
          e.target.value.length > 3 &&
          e.target.value !== '' &&
          e.target.value.length >= passwordUI.length
        ) {
          setPasswordUI(inputString.slice(0, 3) + ' ' + inputString.slice(3, 6));
        } else if (e.target.value.length > 4) {
          setPasswordUI(e.target.value);
        } else {
          setPasswordUI(inputString);
        }
      }
    },
    [passwordUI]
  );
  const handleOk = () => {
    onOk(password);
  };
  const handleClose = () => {
    onClose();
    setPassword('');
    setPasswordUI('');
    inputRef.current?.blur();
  };

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [visible]);

  return (
    <Modal open={visible} className={s.pwdModal} closable={false} footer={null}>
      <div className={s.password}>
        <span className={s.title}>{formatMessage({ id: 'enterPassword' })}</span>
        <Input
          ref={inputRef}
          placeholder=""
          autoFocus
          maxLength={7}
          className={s.input}
          value={passwordUI}
          onChange={onPasswordChange}
        />
      </div>
      <div className={s.btnWrapper}>
        <span className={s.left} onClick={handleClose}>
          {formatMessage({ id: 'CANCEL' })}
        </span>

        <span
          className={classNames(s.right, !password || password.length !== 6 ? s.disabled : '')}
          onClick={handleOk}
        >
          {formatMessage({ id: 'CONFIRM' })}
        </span>
      </div>
    </Modal>
  );
};

export default PwdModal;
